import React from 'react';
import R from 'ramda';
import moment from 'moment';
import { fromJS } from 'immutable';
import ErrorIcon from 'material-ui/svg-icons/alert/error-outline';
import CaretDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

const getDate = fieldName => R.compose(
  R.ifElse(
    R.identity,
    date => moment(date).format('D MMM YYYY'),
    R.identity
  ),
  R.propOr('', fieldName)
);
const getNewForTourplanWhenRateSetDataChanges = (forTourplan, seasonId, rateSetIndex, fieldName, newValue, currentVal) => {
  return forTourplan.map(obj => {
    if (obj.DateRange.seasonId === seasonId) {
      const newDateRange = R.merge(obj.DateRange, {
        RateSet: obj.DateRange.RateSet.map((rateSetObj, thisIndex) => {
          if (!rateSetObj[fieldName] || !currentVal) {
            if (thisIndex === rateSetIndex) return R.merge(rateSetObj, { [fieldName]: newValue });
          } else if (rateSetObj[fieldName] === currentVal) return R.merge(rateSetObj, { [fieldName]: newValue });
          return rateSetObj;
        }),
      });
      return R.merge(obj, { DateRange: newDateRange });
    }
    return obj;
  });
};

const RateNameText = ({ updateThisProductWithKeyPath, convertedContract, updateWithKeyPath, forTourplan, editCarriesTo, checkIfDupeRateNameExistsWithinADateRange }) => {
  const updateFieldStandalone = ({ isInRateSet }) => {
    if (isInRateSet) {
      return (dateRangeIndex, seasonId, rateSetIndex, fieldName, newValue) => {
        updateThisProductWithKeyPath(['forTourplan', dateRangeIndex, 'DateRange', 'RateSet', rateSetIndex, fieldName], newValue);
      };
    }
    return (dateRangeIndex, seasonId, path, value) => {
      updateThisProductWithKeyPath(['forTourplan', dateRangeIndex, 'DateRange', ...path], value);
    };
  }
  const updateFieldForSameSeason = ({ isInRateSet }) => {
    if (isInRateSet) {
      return (dateRangeIndex, seasonId, rateSetIndex, fieldName, newValue, currentVal) => {
        const newData = getNewForTourplanWhenRateSetDataChanges(forTourplan, seasonId, rateSetIndex, fieldName, newValue, currentVal);
        updateThisProductWithKeyPath(['forTourplan'], fromJS(newData));
      };
    }
    return (dateRangeIndex, seasonId, path, value) => {
      const newData = forTourplan.map(obj => {
        if (obj.DateRange.seasonId === seasonId) return R.assocPath(['DateRange', ...path], value, obj);
        return obj;
      });
      updateThisProductWithKeyPath(['forTourplan'], fromJS(newData));
    };
  };
  const updateFieldForSameSeasonAcrossProducts = ({ isInRateSet }) => {
    if (isInRateSet) {
      return (dateRangeIndex, seasonId, rateSetIndex, fieldName, newValue, currentVal) => {
        const newConvertedContract = convertedContract.map(product => {
          return {
            ...product,
            forTourplan: getNewForTourplanWhenRateSetDataChanges(product.forTourplan, seasonId, rateSetIndex, fieldName, newValue, currentVal),
          };
        });
        updateWithKeyPath(['convertedContract'], fromJS(newConvertedContract));
      };
    }
    return (dateRangeIndex, seasonId, path, value) => {
      const newData = convertedContract.map(product => {
        return {
          ...product,
          forTourplan: product.forTourplan.map(obj => {
            if (obj.DateRange.seasonId === seasonId) return R.assocPath(['DateRange', ...path], value, obj);
            return obj;
          }),
        };
      });
      updateWithKeyPath(['convertedContract'], fromJS(newData));
    };
  };

  const updateFieldForSameSeasonsAllProducts = ({ isInRateSet }) => {
    if (isInRateSet) {
      return (dateRangeIndex, seasonId, rateSetIndex, fieldName, newValue, currentVal) => {
        if (fieldName === 'Rate_Text' || fieldName === 'Stay_Type') {
          alert('You cannot update all Rate Name or Rate Text to the same value. Please update the edit rule.');
        } else {
          const newData = convertedContract.map(product => {
            return {
              ...product,
              forTourplan: product.forTourplan.map(obj => ({
                ...obj,
                DateRange: {
                  ...obj.DateRange,
                  RateSet: obj.DateRange.RateSet.map(rs => ({
                    ...rs,
                    [fieldName]: newValue,
                  })),
                },
              })),
            };
          });
          updateWithKeyPath(['convertedContract'], fromJS(newData));
        }
      };
    }
    return (dateRangeIndex, seasonId, path, value) => {
      const newData = convertedContract.map(product => {
        return {
          ...product,
          forTourplan: product.forTourplan.map(obj => R.assocPath(['DateRange', ...path], value, obj)),
        };
      });
      updateWithKeyPath(['convertedContract'], fromJS(newData));
    };
  };

  const updateFn = R.call(R.cond([
    [R.equals('sameProduct'), R.always(updateFieldForSameSeason)],
    [R.equals('sameSeasonAcrossProducts'), R.always(updateFieldForSameSeasonAcrossProducts)],
    [R.equals('sameFieldAllSeasonsAllProducts'), R.always(updateFieldForSameSeasonsAllProducts)],
    [R.T, R.always(updateFieldStandalone)],
  ]), editCarriesTo);
  return (
    <div>
      <div style={{ textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px' }}>Rate Name & Rate Text</div>
      {
        /*
         <div>
         <button
         onClick={() => {
         updateThisProductWithKeyPath(['forTourplan'], fromJS(forTourplan.map(obj => {
         const newDateRange = {
         ...obj.DateRange,
         RateSet: obj.DateRange.RateSet.map(R.merge(R.__, {
         Stay_Type: '',
         Rate_Text: '',
         Cancel_Hours: '',
         })),
         };
         return R.merge(obj, { DateRange: newDateRange });
         })));
         }}
         >
         Clear All Texts
         </button>
         </div>
         */
      }
      {
        forTourplan && !R.isEmpty(forTourplan) && forTourplan.map(({ DateRange, collapsed }, index) => {
          const duplicateRateName = checkIfDupeRateNameExistsWithinADateRange(DateRange);
          return (
            <div key={index}>
              <div
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
                onClick={() => updateThisProductWithKeyPath(['forTourplan', index, 'collapsed'], !collapsed)}
              >
                <div style={{ width: '50%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' }}>{getDate('Date_From')(DateRange)} - {getDate('Date_To')(DateRange)}</div>
                <div style={{ color: 'rgba(0, 0, 0, 0.74)', width: '40%', textAlign: 'right', fontSize: '12px' }}>{DateRange.seasonName} {DateRange.eventName ? `-${DateRange.eventName}` : ''}</div>
                <CaretDown style={{ transform: Boolean(collapsed) ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 300ms ease-in-out' }}/>
              </div>

              <div style={{ display: collapsed ? 'none' : 'block' }}>
                <div style={{ marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <div style={{ display: 'inline-block', width: '35%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' }}>Sale From:</div>
                  <input
                    style={{
                      border: DateRange.Sale_From !== DateRange.originalSale_From ? '2px solid #00bcd4' : '2px solid #e0e0e0',
                      flexGrow: 2,
                    }}
                    value={R.pathOr('', ['Sale_From'], DateRange)}
                    onChange={({ target: { value } }) => updateFn({ isInRateSet: false })(index, DateRange.seasonId, ['Sale_From'], value, R.pathOr('', ['Sale_From'], DateRange))}
                  />
                  {
                    R.pathOr('', ['Sale_From'], DateRange) && !R.test(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/, R.pathOr('', ['Sale_From'], DateRange)) && (
                      <small style={{ color: 'red' }}>Please enter date in YYYY-MM-DD format</small>
                    )
                  }
                </div>
                <div style={{ marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <div style={{ display: 'inline-block', width: '35%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' }}>Sale To:</div>
                  <input
                    style={{
                      border: DateRange.Sale_To !== DateRange.originalSale_To ? '2px solid #00bcd4' : '2px solid #e0e0e0',
                      flexGrow: 2,
                    }}
                    value={R.pathOr('', ['Sale_To'], DateRange)}
                    onChange={({ target: { value } }) => updateFn({ isInRateSet: false })(index, DateRange.seasonId, ['Sale_To'], value, R.pathOr('', ['Sale_To'], DateRange))}
                  />
                  {
                    R.pathOr('', ['Sale_To'], DateRange) && !R.test(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/, R.pathOr('', ['Sale_To'], DateRange)) && (
                      <small style={{ color: 'red' }}>Please enter date in YYYY-MM-DD format</small>
                    )
                  }
                </div>
                <div style={{ marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <div style={{ display: 'inline-block', width: '35%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' }}>Tax Code:</div>
                  <input
                    style={{
                      border: (() => {
                        const currentVal = R.pathOr('', ['Taxes', 'TaxInfo', 'Tax'], DateRange);
                        if (!currentVal) return '2px solid #ff9100';
                        if (currentVal !== R.pathOr('', ['originalTaxes', 'TaxInfo', 'Tax'], DateRange)) return '2px solid #00bcd4';
                        return '2px solid #e0e0e0';
                      })(),
                      flexGrow: 2,
                    }}
                    value={R.pathOr('', ['Taxes', 'TaxInfo', 'Tax'], DateRange)}
                    onChange={({ target: { value } }) => {
                      if (value && value.length > 3) alert('Maximum 3 characters allowed.');
                      else updateFn({ isInRateSet: false })(index, DateRange.seasonId, ['Taxes', 'TaxInfo', 'Tax'], value, R.pathOr('', ['Taxes', 'TaxInfo', 'Tax'], DateRange));
                    }}
                  />
                </div>
                <div style={{ marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <div style={{ display: 'inline-block', width: '35%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' }}>Price Codes:</div>
                  <input
                    style={{
                      border: (() => {
                        const currentVal = R.pathOr([], ['PriceCodes'], DateRange).join(',');
                        if (!currentVal) return '2px solid #ff9100';
                        if (currentVal !== R.pathOr([], ['originalPriceCodes'], DateRange).join(',')) return '2px solid #00bcd4';
                        return '2px solid #e0e0e0';
                      })(),
                      flexGrow: 2,
                    }}
                    value={R.pathOr([], ['PriceCodes'], DateRange).join(',')}
                    onChange={({ target: { value } }) => {
                      updateFn({ isInRateSet: false })(index, DateRange.seasonId, ['PriceCodes'], value.split(','), R.pathOr('', ['PriceCodes'], DateRange));
                    }}
                  />
                </div>
                {
                  !/^[a-zA-Z0-9,]*$/.test(R.pathOr([], ['PriceCodes'], DateRange).join(','))
                  && (
                    <div style={{ color: '#ff4081' }}>
                      <small>Please separate price codes using commas only.</small>
                    </div>
                  )
                }
              {
                duplicateRateName && (<span style={{ display: 'flex', alignItems: 'base-line', margin: '4px 0', color: 'red' }}>
                <ErrorIcon color="red"/>
                  &nbsp;&nbsp;Rate Names must be unique amongst the rate sets that belong to a single range.
              </span>)
              }
              {
                DateRange.RateSet.map((rateSet, rateSetIndex) => {
                  return (
                    <div key={rateSetIndex} style={{ margin: '8px 0', display: 'flex' }}>
                      {
                        /*
                         <div>{rateSetIndex + 1}</div>
                         */
                      }
                      <div style={{ flexGrow: 2 }}>
                        <div style={{ marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                          <div style={{ display: 'inline-block', width: '35%' }}>Rate Name:</div>
                          <input
                            style={{ border: rateSet.Stay_Type !== rateSet.originalStay_Type ? '2px solid #00bcd4' : '2px solid #e0e0e0', flexGrow: 2 }}
                            value={R.propOr('', 'Stay_Type', rateSet)}
                            onChange={({ target: { value } }) => {
                              if (value && value.length > 20) alert('Maximum 20 characters allowed.');
                              else updateFn({ isInRateSet: true })(index, DateRange.seasonId, rateSetIndex, 'Stay_Type', value, R.propOr('', 'Stay_Type', rateSet));
                            }}
                          />
                        </div>
                        <div style={{ marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                          <div style={{ display: 'inline-block', width: '35%' }}>Rate Text:</div>
                          <input
                            style={{ border: rateSet.Rate_Text !== rateSet.originalRate_Text ? '2px solid #00bcd4' : '2px solid #e0e0e0', flexGrow: 2 }}
                            value={R.propOr('', 'Rate_Text', rateSet)}
                            onChange={({ target: { value } }) => {
                              if (value && value.length > 60) alert('Maximum 60 characters allowed.');
                              else updateFn({ isInRateSet: true })(index, DateRange.seasonId, rateSetIndex, 'Rate_Text', value, R.propOr('', 'Rate_Text', rateSet));
                            }}
                          />
                        </div>
                        <div style={{ marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                          <div style={{ display: 'inline-block', width: '35%' }}>Cancel Hours:</div>
                          <input
                            type="number"
                            style={{ border: (rateSet.Cancel_Hours || '').toString() !== (rateSet.originalCancel_Hours || '').toString() ? '2px solid #00bcd4' : '2px solid #e0e0e0', flexGrow: 2 }}
                            value={R.propOr('', 'Cancel_Hours', rateSet)}
                            onChange={({ target: { value } }) => updateFn({ isInRateSet: true })(index, DateRange.seasonId, rateSetIndex, 'Cancel_Hours', value, R.propOr('', 'Cancel_Hours', rateSet))}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })
              }
              </div>
            </div>
          );
        })
      }
    </div>);
};

export default RateNameText;



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-content-preview/preview-rate-name-text.jsx